export default __webpack_public_path__ + "static/media/Adding-Dropdown-Values.107ed88a.svg";